import cx from 'classnames';
import { GatsbyImageProps, IGatsbyImageData } from 'gatsby-plugin-image';
import React, { useEffect, useRef, useState } from 'react';
import ReactPlayer from 'react-player';

import { Breadcrumbs, Image } from '../../index';
import * as styles from './Hero.module.css';

const Hero = ({
	children,
	image,
	alt,
	video,
	theme = 'darkBlue',
	hasPullSibling = false,
	deep,
	breadcrumbs,
	pagePath,
	className = '',
	contentClassName,
	fullscreen = false,
}: {
	children: React.ReactNode;
	image: GatsbyImageProps | IGatsbyImageData | undefined;
	alt: string;
	video?: {
		mp4: string;
		webm: string;
		poster: string;
	};
	theme?: 'lightBlue' | 'darkBlue' | 'vertGrey' | 'none';
	hasPullSibling?: boolean;
	deep?: boolean;
	breadcrumbs?: boolean;
	pagePath?: string;
	className?: string;
	contentClassName?: string;
	fullscreen?: boolean;
}) => {
	return (
		<section
			className={cx(styles.hero, styles[theme], className, {
				[styles.hasPullSibling]: hasPullSibling,
				[styles.deep]: deep,
				[styles.fullscreen]: fullscreen,
			})}
		>
			{breadcrumbs && pagePath && <Breadcrumbs pagePath={pagePath} />}
			<div className={styles.image}>
				{video && (
					<HeroVideo
						mp4Src={video.mp4}
						webmSrc={video.webm}
						className={styles.video}
						poster={video.poster}
						playsinline
					/>
				)}

				{image && !video && <Image image={image} alt={alt} lazy="eager" />}
			</div>
			<div className={cx(styles.layout)}>
				<div className={cx(styles.content, contentClassName)}>{children}</div>
			</div>
		</section>
	);
};

const HeroVideo = ({
	mp4Src,
	webmSrc,
	className,
	poster,
}: {
	mp4Src: string;
	webmSrc: string;
	className?: string;
	poster: string;
}) => {
	const [hasWindow, setHasWindow] = useState(false);
	useEffect(() => {
		if (typeof window !== 'undefined') {
			setHasWindow(true);
		}
	}, []);

	const videoPlayer = useRef(null);

	return (
		<>
			{hasWindow && (
				<ReactPlayer
					width="100%"
					height="100%"
					url={mp4Src}
					// url={[
					// 	{ src: mp4Src, type: 'video/mp4' },
					// 	{ src: webmSrc, type: 'video/webm' }
					// ]}
					controls={false}
					playing={true}
					config={{
						file: {
							attributes: {
								poster: poster,
							},
						},
					}}
					muted
					loop
					className={cx(styles.video, className)}
					ref={videoPlayer}
					playsinline
				/>
			)}
		</>
	);
};

export default Hero;
